// extracted by mini-css-extract-plugin
module.exports = {"icon-label":"IconLabel_icon-label__2MhLq","icon-label__text":"IconLabel_icon-label__text__2NXtm","icon-label__icon":"IconLabel_icon-label__icon__1gBc_"};